import './App.css';

// Post body only. The title and date live in postRegistry.js and are rendered
// by Blog.js, so there is no date div and no <h2> in here.

function Oct132026() {
    return (
        <>
        <div className='blog-post'>
        <p>So the vigar.net domain is registered. And content will start being more refreshed.</p>
        <p>I was conflicted about keeping the pre-AI design because I'm not much of a front-end developer, but I thought it was neat to toggle between what agentic builds and manual builds were looking like for this project.</p>
        <p>Granted, the last time I came back to this project was about a year or so ago. A lot's changed since then, skill, design and technology-wise, which is very interesting.</p>
        <p>So please enjoy the new content. Please stop by when you can. Please message me if you just want to talk about technology or solutions. Philosophy of technology and AI is a big one for me. I want to hear about the projects too.</p>
        </div>
        </>
    );
}

export default Oct132026;
